import { DialogTitle, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getColor } from "../color/color";
import { fonts } from "../fonts/fonts";

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  textTransform: "capitalize",
  color: getColor.SecondaryMidnightBlue,
  fontSize: { xs: "20px", md: "24px" },
  fontFamily: fonts.manrope,
  fontWeight: 700,
  lineHeight: "28px",
  marginTop: "20px",
}));

export const StyleTypography = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.inter,
  color: getColor.Gunmetal,
  marginTop: "10px",
  marginBottom: "30px",
  fontSize: { xs: "14px", md: "16px" },
}));
export const StyledResendOTP = styled(Typography)(({ theme, timer }) => ({
  fontFamily: fonts.manrope,
  fontWeight: 600,
  fontSize: { xs: "12px", md: "14px" },
  color: timer !== 0 ? "gray" : "#030383",
  lineHeight: "16px",
  marginRight: theme.spacing(1),
  cursor: timer === 0 ? "pointer" : "not-allowed",
}));

export const styledOTPInputProps = {
  width: "40px",
  height: "50px",
  margin: "0 5px",
  fontSize: "20px",
  textAlign: "center",
  borderRadius: "8px",
  border: "1px solid lightgray",
};
export const styledACRButton = {
  width: "70%",
  maxWidth: "350px",
  backgroundColor: getColor.ColorButtonPrimarysurface,
  color: getColor.PrimaryWhite,
  borderRadius: "40px",
  padding: "20px",
  lineHeight: "22.2px",
  fontWeight: 400,
  fontSize: "16px",
  fontFamily: fonts.manrope,
  textAlign: "center",
  textTransform: "capitalize",
  margin: 0,
};
